import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, OnInit } from '@angular/core';

import { nif } from './validator';

@Directive({
    selector: '[nif][formControlName],[nif][formControl],[nif][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => NIFValidatorDirective),
            multi: true,
        },
    ],
})
export class NIFValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = nif();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
